export const HOME_SEARCH_TYPE = 'home';
export const QUERY_SEARCH_TYPE = 'query';
export const WATCHED_SEARCH_TYPE = 'watched';
export const QUEUE_SEARCH_TYPE = 'queue';
